// Prices travel as integer cents so quantity × unit price stays exact.
export const formatPrice = (cents: number, currency = 'EUR', locale = 'nl-NL') => new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
